// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__GmCIW","zoomable":"Avatar_zoomable__V9kfp","alert-modal":"Avatar_alert-modal__Flb21"};